export default __webpack_public_path__ + "static/media/TaskImageIndividual.81b761cf.svg";